export default function DomotiqueFeatures() {
  const features = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Éclairage Intelligent',
      description: 'Contrôlez l\'éclairage de votre maison depuis votre smartphone. Programmez des scénarios, ajustez l\'intensité et créez des ambiances personnalisées pour chaque pièce.'
    },
    {
      icon: 'ri-temp-hot-line',
      title: 'Gestion du Chauffage',
      description: 'Optimisez votre consommation énergétique avec une gestion intelligente du chauffage. Programmation horaire, détection de présence et contrôle à distance pour un confort optimal.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Sécurité Connectée',
      description: 'Surveillez votre domicile en temps réel avec des caméras connectées, détecteurs de mouvement et alarmes intelligentes. Recevez des alertes instantanées sur votre téléphone.'
    },
    {
      icon: 'ri-window-line',
      title: 'Volets Automatisés',
      description: 'Automatisez l\'ouverture et la fermeture de vos volets selon l\'heure, la luminosité ou vos préférences. Contrôle centralisé et programmation personnalisée.'
    },
    {
      icon: 'ri-music-line',
      title: 'Audio Multiroom',
      description: 'Diffusez votre musique préférée dans toutes les pièces de votre maison. Système audio centralisé avec contrôle individuel par zone et synchronisation parfaite.'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Contrôle Centralisé',
      description: 'Une seule application pour gérer tous vos équipements. Interface intuitive compatible iOS et Android pour un contrôle total de votre maison intelligente.'
    }
  ];

  return (
    <section className="py-24 bg-gray-950">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-base font-semibold leading-7 text-orange-400">Fonctionnalités</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Solutions Domotiques Complètes
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-400 max-w-3xl mx-auto">
            Découvrez nos solutions domotiques pour automatiser et sécuriser votre habitat en Suisse. Confort, économies d'énergie et sécurité réunis dans un système intelligent et évolutif.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gray-900 p-8 rounded-2xl border border-gray-800 hover:border-orange-500/40 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-orange-500/20 rounded-xl mb-6">
                <i className={`${feature.icon} text-3xl text-orange-400`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
              <p className="text-gray-400 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
